import axios from "axios";
import { count } from "firebase/firestore";
import { useEffect, useState } from "react";
import NotPaid from "../../../utilities/not-paid";
import Cookies from "js-cookie";
import NotUser from "../../../utilities/not-user";
import { CircleLoader } from "react-spinners";

const UserEdit = () => {

    const [existingCompanies, setExistingCompanies] = useState([]);
    const [targetCompany, setCompany] = useState('');
    const [status, setStatus] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [id, setID] = useState(0);
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [position, setPosition] = useState('');
    const [currentUser, setUser] = useState();

    const [firstnameChanged, setFirstNameChanged] = useState(false)
    const [lastnameChanged, setLastNameChanged] = useState(false)
    const [emailChanged, setEmailChanged] = useState(false)
    const [phoneChanged, setPhoneChanged] = useState(false)
    const [positionChanged, setPositionChanged] = useState(false)

    const [change, setChange] = useState(false)


    const test_get_user_link = "http://localhost:3000/current/user/"
    const production_get_user_link = "https://apple-tree-server.vercel.app/current/user"
    
    const test_update_user_link = "http://localhost:3000/update/user/"
    const production_update_user_link = "https://apple-tree-server.vercel.app/update/user"
    

    const getUser = async () => {
        const user_id = Cookies.get('token_id');

        await axios.post(production_get_user_link, {
            user_id
        })
        .then(response => {
            console.log(response.data[0]);
            const user = response.data[0];
            setUser(user);
            setFirstName(user.first_name);
            setLastName(user.last_name);
            setEmail(user.email);
            setPhone(user.phone);
            setPosition(user.position)

            // setExistingCompanies(response.data);
        })
        .catch(error => console.log(error))
    }

    const updateUser = async () => {
        const user_id = Cookies.get('token_id');
        // axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';

        await axios.post(production_update_user_link, {
            user_id,
            firstName,
            lastName,
            email,
            phone,
            position
        })
        .then((response) => {
            alert('Profile updated successfully!')
            window.location.reload();
        })
        .catch((error) => {
            console.warn(error);
        })
    }

    let count = 0;

    useEffect(() => {
        getUser()
    }, []);

    function checkAnyChange() {
        
        if (checkChange(firstName, currentUser.first_name, "firstname")
        ||checkChange(lastName, currentUser.last_name, "lastname")
        ||checkChange(email, currentUser.email, "email") 
        || checkChange(phone, currentUser.phone, "phone") 
        || checkChange(position, currentUser.position, "position")) {
            setChange(true);
        } else {
            setChange(false)
        }
       
       
    }

    useEffect(() => {
        if (currentUser != null) {
            checkAnyChange();

            setFirstNameChanged(checkChange(firstName, currentUser.first_name, "firstname"));
            setLastNameChanged(checkChange(lastName, currentUser.last_name, "lastname"));
            setEmailChanged(checkChange(email, currentUser.email, "email"));
            setPhoneChanged(checkChange(phone, currentUser.phone, "phone"));
            setPositionChanged(checkChange(position, currentUser.position, "position"));

        }

        
        
    }, [firstName, lastName, email, phone,position])

    useEffect(() => {
        if (document.getElementById('change-button') != null) {
            if (change) {
            
            document.getElementById('change-button').disabled = false;
 
        } else {
            document.getElementById('change-button').disabled = true;

        }
        }
        
    }, [change]);



    const company = Cookies.get(`token_company`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);


    if (!firstname || !lastname || !company) {
        return (
                <NotUser/>
        )
    }

    const statusNow = Cookies.get(`token_status`);

    if (statusNow != 'Paid') {
        return (
            <NotPaid/>
        )
    }

    const checkChange = (value, original, id) => {
       
        if (value != original) {
            document.getElementById(id).classList.add('text-primary')
            return true
        } else {
            document.getElementById(id).classList.remove('text-primary')
            return false
        }
    }

    if (currentUser == null) {
        return (
            <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center ">
                
                            <CircleLoader size={200} color="#cdc59a"/>
            </div>
        )
    }


    return ( 
<div className={`container-fluid d-flex justify-content-center`}>        
            

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Update {targetCompany.name}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Save your changes? 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" onClick={() => {
            updateUser();
        }}>Yes</button>
      </div>
    </div>
  </div>
</div>
            
                <form className={` border p-4 rounded w-100 mt-5 d-flex flex-column justify-content-center align-items-center `} onSubmit={(e) => {
                }}>        
                    <h1 className=" text-muted display-4 fw-light mb-4">My profile</h1>

                    <label for='company' className="form-label">First Name:</label>
                    
                    <input  style={{
                        textAlign:"center",
                        color: "lightgray"
                    }} id="firstname" name="company" className="form-control mb-3 w-75" onChange={(e) => {
                        setFirstName(e.target.value);
                        checkAnyChange()
                    }} value={firstName}/>

<label for='company' className="form-label">Last Name:</label>


                    <input style={{
                        textAlign:"center",
                        color: "lightgray"
                    }} id="lastname" name="company" className="form-control mb-3 w-75" onChange={(e) => {
                        setLastName(e.target.value)
                        checkAnyChange()

                    }} value={lastName}/>

<label for='company' className="form-label"> Email:</label>

                    <input style={{
                        textAlign:"center",
                        color: "lightgray"
                    }}  id="email" name="company" className="form-control mb-3 w-75" onChange={(e) => {
                        setEmail(e.target.value)
                        checkAnyChange()

                    }} value={email}/>

<label for='company' className="form-label">Phone:</label>


                    <input style={{
                        textAlign:"center",
                        color: "lightgray"
                    }} id="phone" name="company" className="form-control mb-3 w-75" onChange={(e) => {
                        setPhone(e.target.value)
                        checkAnyChange()

                    }} value={phone}/>        

                    
<label for='company' className="form-label">Position:</label>


                    <input style={{
                        textAlign:"center",
                        color: "lightgray"
                    }} id="position" name="company" className="form-control mb-3 w-75" onChange={(e) => {
                        setPosition(e.target.value)
                        checkAnyChange()

                    }} value={position}/>                

                    <p className="text-danger text-center">{error}</p>
                    <div   className="mt-3 d-flex justify-content-center">
                        {!isLoading &&  <button data-bs-toggle="modal" data-bs-target="#exampleModal"  id="change-button" class={`btn btn-primary text-light `} onClick={(e) => {
                            e.preventDefault();
                            }}>Change</button>}
                        {isLoading && 
                        <button class="btn btn-secondary" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </button>
                        }
                    </div>

                </form>
            
        </div>
     );
}
 
export default UserEdit;